import './App.css';
import Footer from './pages/footer/Footer';
import Home from './pages/home/Home'
import Search from './pages/search/Search';

function App() {
  return (
    <div className="App">
      <Search />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
